import React from "react";
import { Box, keyframes, usePrefersReducedMotion } from "@chakra-ui/react";

const drift = keyframes`
  0%   { transform: translate3d(0, 0, 0) rotate(0deg); }
  50%  { transform: translate3d(6px, -18px, 0) rotate(8deg); }
  100% { transform: translate3d(0, 0, 0) rotate(0deg); }
`;

// Paint drops in festival colors, kept to the edges so they never sit on text.
const DOTS = [
  { top: "14%", left: "4%", size: 26, color: "#0C7FBC", delay: 0, mobile: true },
  { top: "32%", left: "9%", size: 12, color: "#FFD52E", delay: 1.2 },
  { top: "58%", left: "3%", size: 18, color: "#D6336C", delay: 0.6, mobile: true },
  { top: "78%", left: "11%", size: 10, color: "#F47A22", delay: 2.1 },
  { top: "88%", left: "5%", size: 22, color: "#8B2A94", delay: 1.6 },
  { top: "12%", left: "93%", size: 20, color: "#F47A22", delay: 0.9, mobile: true },
  { top: "30%", left: "88%", size: 12, color: "#0C7FBC", delay: 2.4 },
  { top: "52%", left: "95%", size: 26, color: "#FFD52E", delay: 0.3, mobile: true },
  { top: "70%", left: "89%", size: 14, color: "#D73522", delay: 1.8 },
  { top: "86%", left: "94%", size: 18, color: "#34B8E8", delay: 1.1 },
];

// startDelay holds the drift until the page has finished loading.
const FloatingPaint = ({ opacity = 0.75, startDelay = 0 }) => {
  const reduceMotion = usePrefersReducedMotion();

  return (
    <Box position="absolute" inset="0" pointerEvents="none" aria-hidden="true" zIndex={1}>
      {DOTS.map((dot, index) => (
        <Box
          key={index}
          position="absolute"
          top={dot.top}
          left={dot.left}
          w={`${dot.size}px`}
          h={`${dot.size}px`}
          display={{ base: dot.mobile ? "block" : "none", md: "block" }}
          bg={dot.color}
          opacity={opacity}
          // Hand-painted blob shape rather than a perfect circle.
          borderRadius="58% 42% 55% 45% / 45% 55% 45% 55%"
          boxShadow={`0 4px 12px ${dot.color}55`}
          animation={reduceMotion ? undefined : `${drift} ${6 + (index % 4)}s ease-in-out ${dot.delay + startDelay}s infinite`}
        />
      ))}
    </Box>
  );
};

export default FloatingPaint;
